import { z } from 'zod';

export const MarriageRelationshipDataSchema = z.object({
  divorceDate: z.string().nullable(), // Optional, if the marriage is dissolved
});

export type IMarriageRelationshipData = z.infer<
  typeof MarriageRelationshipDataSchema
>;

export function getEmptyMarriageRelationshipData(): IMarriageRelationshipData {
  return {
    divorceDate: null,
  };
}
